import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

interface OrganizationSectionCardProps {
	title: string;
	description: string;
	icon: ReactNode;
	path: string;
}

export const OrganizationSectionCard: React.FC<OrganizationSectionCardProps> = ({
	title,
	description,
	icon,
	path,
}) => {
	const navigate = useNavigate();

	return (
		<div
			className="rounded-lg p-4 hover:bg-slate-100 transition-colors cursor-pointer group"
			onClick={() => navigate(path)}
		>
			<div className="flex items-start justify-between mb-2">
				<div className="flex items-start gap-3">
					<div className="p-2 mt-0.5 bg-slate-50 rounded-lg group-hover:bg-slate-100 transition-colors">
						{icon}
					</div>
					<div>
						<h3 className="font-medium text-md text-slate-900">{title}</h3>
						<p className="text-slate-600 leading-relaxed text-sm">
							{description}
						</p>
					</div>
				</div>
			</div>

		</div>
	);
};